export default {
    activeBgStyle: {
        visibleOn: ['normal', 'hover'],
        template: 'Tab',
        inputType: 'boxed',
        defaultValue: 'color',
        label: 'Background Style',
        options: [
            { label: 'Color', value: 'color' },
            { label: 'Gradient', value: 'gradient' },
            { label: 'Image', value: 'image' },
            // { label: "Video", value: "video" },
            // { label: "Special", value: "special" }
        ],
    },
    service: {
        label: 'Service',
        template: 'Select',
        options: [
            { name: 'MailChimp', value: 'mailchimp' },
            { name: 'EmailOctopus', value: 'emailoctopus' },
            { name: 'Mailerlite', value: 'mailerlite' },
            { name: 'ActiveCampaign', value: 'activecampaign' },
            { name: 'ConvertKit', value: 'convertkit' },
            { name: 'Sendinblue', value: 'sendinblue' },
            { name: 'Zapier', value: 'zapier' },
            { name: 'Integromat', value: 'integromat' },
            { name: 'Pabbly Connect', value: 'pabbly' },
        ],
    },
    hideOn: {
        label: 'Hide On',
        template: 'Select',
        options: [
            { name: 'None', value: '' },
            { name: 'Mobile', value: 'mobile' },
            { name: 'Mobile & Tablet', value: 'mobile+tablet' },
            { name: 'Mobile & Desktop', value: 'mobile+desktop' },
            { name: 'Tablet', value: 'tablet' },
            { name: 'Tablet & Desktop', value: 'tablet+desktop' },
            { name: 'Desktop', value: 'desktop' },
        ],
    },
};
